module.exports = __webpack_public_path__ + "static/media/BTCU_WP.0214bc82.pdf";